module.exports = __webpack_public_path__ + "app-static/img/p_05.973fba71.jpg";